import { weekdayLabels, leadingBlanks } from "./palette";

const iso = (y, m, d) => `${y}-${String(m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

export const YearView = ({ year, busyDays, holidays, todayISO, accent, weekStarts, onPickMonth, onPickDay }) => (
  <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="year-view">
    {Array.from({ length: 12 }, (_, month) => {
      const total = new Date(year, month + 1, 0).getDate();
      const lead = leadingBlanks(new Date(year, month, 1), weekStarts);
      return (
        <div key={month} className="rounded-2xl border border-white/10 bg-panel p-3"
             data-testid={`year-month-${month + 1}`}>
          <button
            onClick={() => onPickMonth(month)}
            data-testid={`year-open-${month + 1}`}
            className="text-[11px] font-semibold uppercase tracking-widest transition-opacity hover:opacity-80"
            style={{ color: accent }}
          >
            {new Date(year, month, 1).toLocaleDateString(undefined, { month: "long" })}
          </button>
          <div className="mt-2 grid grid-cols-7 gap-1 text-center text-[9px] text-ink-soft">
            {weekdayLabels(weekStarts).map((d) => (
              <span key={d}>{d.slice(0, 1)}</span>
            ))}
          </div>
          <div className="mt-1 grid grid-cols-7 gap-1">
            {Array.from({ length: lead }, (_, i) => <span key={`p${i}`} />)}
            {Array.from({ length: total }, (_, i) => {
              const day = iso(year, month, i + 1);
              const busy = busyDays[day] || 0;
              const feast = holidays[day];
              return (
                <button
                  key={day}
                  onClick={() => onPickDay(day)}
                  data-testid={`year-day-${day}`}
                  title={feast || (busy ? `${busy} event${busy === 1 ? "" : "s"}` : day)}
                  className="flex h-5 items-center justify-center rounded text-[9px] tabular-nums transition-colors"
                  style={{
                    color: day === todayISO ? "#0B0F14" : feast ? "#c4b5fd" : busy ? "#E6EAF2" : "#6B7280",
                    backgroundColor: day === todayISO ? accent : busy ? `${accent}33` : "transparent",
                    fontWeight: busy || feast ? 700 : 400,
                  }}
                >
                  {i + 1}
                </button>
              );
            })}
          </div>
        </div>
      );
    })}
  </div>
);
